/**
 * Named type roles, matching the reference's compact dashboard proportions.
 * Headings tighten their tracking; metrics and table numbers use tabular
 * figures; nav group labels are the one place uppercase is used.
 */
export const textStyles = {
  /** Authentication screen only. */
  display: {
    value: {
      fontSize: '4xl',
      fontWeight: 'bold',
      lineHeight: 'tight',
      letterSpacing: 'tighter',
      color: 'fg.strong',
    },
  },
  pageTitle: {
    value: {
      fontSize: '2xl',
      fontWeight: 'semibold',
      lineHeight: 'tight',
      letterSpacing: 'tighter',
      color: 'fg.strong',
    },
  },
  pageDescription: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'fg.muted' },
  },
  sectionTitle: {
    value: {
      fontSize: 'xl',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'tight',
      color: 'fg.strong',
    },
  },
  cardTitle: {
    value: {
      fontSize: 'lg',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'tight',
      color: 'fg.strong',
    },
  },
  metricValue: {
    value: {
      fontSize: '3xl',
      fontWeight: 'semibold',
      lineHeight: 'none',
      letterSpacing: 'tighter',
      color: 'fg.strong',
      fontVariantNumeric: 'tabular-nums',
    },
  },
  body: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'fg.default' },
  },
  bodySmall: {
    value: { fontSize: 'sm', fontWeight: 'normal', lineHeight: 'normal', color: 'fg.default' },
  },
  bodyStrong: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'normal', color: 'fg.default' },
  },
  bodySecondary: {
    value: { fontSize: 'md', fontWeight: 'normal', lineHeight: 'normal', color: 'fg.muted' },
  },
  label: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'snug', color: 'fg.default' },
  },
  helperText: {
    value: { fontSize: 'xs', fontWeight: 'normal', lineHeight: 'snug', color: 'fg.muted' },
  },
  caption: {
    value: { fontSize: 'xs', fontWeight: 'normal', lineHeight: 'snug', color: 'fg.subtle' },
  },
  navLabel: {
    value: { fontSize: 'md', fontWeight: 'medium', lineHeight: 'snug', letterSpacing: 'tight' },
  },
  /** The one uppercase role: sidebar group headings. */
  navGroup: {
    value: {
      fontSize: '2xs',
      fontWeight: 'semibold',
      lineHeight: 'snug',
      letterSpacing: 'wide',
      textTransform: 'uppercase',
      color: 'fg.subtle',
    },
  },
  tableHeader: {
    value: { fontSize: 'xs', fontWeight: 'medium', lineHeight: 'snug', color: 'fg.muted' },
  },
  tableCell: {
    value: { fontSize: 'sm', fontWeight: 'normal', lineHeight: 'snug', color: 'fg.default' },
  },
  numeric: {
    value: {
      fontSize: 'sm',
      fontWeight: 'medium',
      lineHeight: 'snug',
      color: 'fg.default',
      fontVariantNumeric: 'tabular-nums',
    },
  },
  /** Identifiers such as reference codes. */
  code: {
    value: {
      fontFamily: 'mono',
      fontSize: 'sm',
      fontWeight: 'normal',
      lineHeight: 'snug',
      color: 'fg.default',
    },
  },
  badgeText: {
    value: { fontSize: '2xs', fontWeight: 'medium', lineHeight: 'snug' },
  },
}
